import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react'
import { X } from 'lucide-react';
import { useSelector } from '@/store/Store';
import Translatable from '../translatable_text/Translatable';
import { cn } from '@/lib/utils';

type Props = {
  title?: string;
  trigger: any;
  subtitle?: string;
  components?: any;
  open?: any;
  setOpen?: any;
  isDisabled?: boolean;
  withHeader?: boolean;
}

export default function CustomDialog({title, components, trigger, subtitle, open, setOpen, withHeader = true}: Props) {

  const dir = useSelector((state) => state.customizer.activeDir)
  
  return (
    <>
      {trigger}

      <Dialog translate='no' open={open} as="div" className="relative z-50 focus:outline-none bg-slate-600" onClose={() => setOpen(false)} __demoMode>
        <div dir={dir} className="fixed inset-0 z-10 w-screen overflow-y-auto bg-background/20 backdrop-blur-sm">
          <div className="relative">
            <DialogPanel
              transition
              className="fixed left-[50%] top-[50%] z-50 grid max-h-[90vh] overflow-scroll w-full max-w-[90vw] md:max-w-[65vw] translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background  px-10 py-10 md:p-10 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg"
            >
              {withHeader && <DialogTitle as="h3" className={cn("bg-sky-100 font-semibold px-6 py-6 rounded-md")}>
                { title && <Translatable>
                  {title}
                </Translatable>}
                <p className='text-gray-400 font-normal text-sm'>
                  { subtitle && <Translatable>
                    {subtitle}
                  </Translatable>}
                </p>
              </DialogTitle>}
              <div className="w-full">
                {components}
              </div>
              <button onClick={() => setOpen(false)} className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground">
                <X className="h-4 w-4" />
                <span className="sr-only">Close</span>
              </button>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </>
  )
}
